export default [

     {
          path: '/mitigation-action',
          name: 'MitigationAction',
          component: () => import("@/views/Page/MitigationAction/MitigationAction.vue"),
           meta: {
               title: '#Default# | MitigationAction',
          },
     }
];